import api from "src/services/api";

export interface PreguntaReconocimiento {
  id: number;
  seccion: string; // ESTRUCTURA | RELEVAMIENTO
  pregunta: string;
  tipo_respuesta: string; // ESTRUCTURA | SI_NO_NA
  orden?: number;
  activo?: number | boolean;
}

export interface OpcionReconocimiento {
  tipo_respuesta: string;
  codigo: string;
  etiqueta: string;
  orden?: number;
}

export interface ContextoReconocimiento {
  ps_id: number;
  ps_codigo?: string;
  ps_nombre?: string;
  fiscal?: { id?: number; nombre?: string };
}

export interface RespuestaReconocimientoPayload {
  pregunta_id: number;
  respuesta_codigo: string;
  comentario?: string;
}

export interface FotoReconocimientoPayload {
  data_url?: string;
  public_id?: string;
  url_secure?: string;
  nombre_archivo?: string;
  mime_type?: string;
  descripcion?: string;
  orden?: number;
}

export interface CrearReconocimientoPayload {
  es_prospecto: boolean;
  ps_id?: number;
  ps_codigo?: string;
  ps_nombre: string;
  prospecto_direccion?: string;
  prospecto_contacto?: string;
  latitud?: number;
  longitud?: number;
  fecha_visita: string;
  fiscal?: { id?: number; nombre?: string };
  plan_accion?: string;
  fecha_plan_accion?: string;
  comentario_general?: string;
  respuestas: RespuestaReconocimientoPayload[];
  fotos?: FotoReconocimientoPayload[];
}

export interface ReconocimientoListItem {
  id: number;
  ps_id?: number;
  ps_codigo?: string;
  ps_nombre?: string;
  es_prospecto?: number | boolean;
  fecha_visita: string;
  fiscal_nombre?: string;
  creado_por_usuario?: string;
  creado_por_cargo?: string;
  creado_en?: string;
}

const BASE = "evaluacion-reconocimiento";

export async function listarPreguntasReconocimiento(): Promise<PreguntaReconocimiento[]> {
  const { data } = await api.get(`${BASE}/preguntas`);
  return data?.datos || [];
}

export async function listarOpcionesReconocimiento(): Promise<OpcionReconocimiento[]> {
  const { data } = await api.get(`${BASE}/opciones`);
  return data?.datos || [];
}

export async function obtenerContextoReconocimiento(
  psId?: number,
  psCodigo?: string | number
): Promise<ContextoReconocimiento | null> {
  const q = new URLSearchParams();
  if (psId) q.append("ps_id", String(psId));
  if (psCodigo !== undefined && psCodigo !== null && String(psCodigo).trim()) {
    q.append("ps_codigo", String(psCodigo).trim());
  }
  const suffix = q.toString() ? `?${q.toString()}` : "";
  const { data } = await api.get(`${BASE}/contexto${suffix}`);
  return data?.datos || null;
}

export async function crearReconocimiento(
  payload: CrearReconocimientoPayload
): Promise<{ id?: number }> {
  const { data } = await api.post(`${BASE}/`, payload);
  if (data?.error) throw new Error(data.error);
  return data?.datos || {};
}

export async function listarReconocimientos(params?: {
  ps_id?: number;
  desde?: string;
  hasta?: string;
  limit?: number;
  offset?: number;
}): Promise<ReconocimientoListItem[]> {
  const q = new URLSearchParams();
  if (params?.ps_id) q.append("ps_id", String(params.ps_id));
  if (params?.desde) q.append("desde", params.desde);
  if (params?.hasta) q.append("hasta", params.hasta);
  if (params?.limit) q.append("limit", String(params.limit));
  if (params?.offset) q.append("offset", String(params.offset));
  const suffix = q.toString() ? `?${q.toString()}` : "";
  const { data } = await api.get(`${BASE}/listar${suffix}`);
  return data?.datos || [];
}
